import * as moment from "moment";
import 'moment-duration-format';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'duration', pure: true})
export class DurationPipe implements PipeTransform {
  public transform(value: any, units: any = 'seconds'): any {
    return (moment.duration(value,units) as any).format();
  }
}